import { ButtonGroup, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

type CustomNavbarProps = {
  onPreviousClick?(): void;
  onNextClick?(): void;
};

export const Navbar: React.FC<React.PropsWithChildren<CustomNavbarProps>> = ({
  onPreviousClick,
  onNextClick,
}) => {
  // if (!onPreviousClick && !onNextClick) {
  //   throw new Error(
  //     'At least one of onPreviousClick or onNextClick must be provided'
  //   );
  // }
  const { t } = useTranslation(['common']);
  return (
    <ButtonGroup size="sm" variant="@secondary">
      {onPreviousClick && (
        <IconButton
          aria-label={t('common:timeAndDate.nextMonth')}
          icon={<FiChevronLeft fontSize="24px" />}
          float="right"
          variant="link"
          onClick={onPreviousClick}
        />
      )}
      {onNextClick && (
        <IconButton
          aria-label={t('common:timeAndDate.previousMonth')}
          icon={<FiChevronRight fontSize="24px" />}
          float="right"
          variant="link"
          onClick={onNextClick}
        />
      )}
    </ButtonGroup>
  );
};
